import MasterStatusModel from '../Apis/MasterStatus.js'
import Controller from './Controller.js';

export default class MasterStatusController extends Controller {

    constructor() {
        super(new MasterStatusModel());
    }

  
}